import React from 'react';
import PropTypes from 'prop-types';
import Textarea from 'react-textarea-autosize';
import {
  FormGroup,
  FormFeedback,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminEditButtons from '../EditButtons';

import ErrorBoundary from '../../ErrorBoundary';

const AdminRoleEditMainEdit = ({
  role,
  roleId,
  errors,
  handleChange,
  handleDelete,
  ...props
}) => {
  const intl = useIntl();

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <p>
          {intl.formatMessage({
            defaultMessage: `Edit the Custom Role name and description. Use the
              description area to explain the capabilities of this Custom
              Role for reference when assigning it to users.`,
          })}
        </p>
        <div className="profile-form">
          <div className="profile-avatar-wrapper">
            <div className="profile-avatar">
              <div className="avatar avatar-200 icon-avatar gray">
                <i className="far fa-user-lock" />
              </div>
            </div>
          </div>
          <div className="profile-details">
            <FormGroup>
              <Label for="inpRoleName">
                {intl.formatMessage({ defaultMessage: 'Name' })}
              </Label>
              <Input
                type="text"
                name="name"
                id="inpRoleName"
                placeholder={intl.formatMessage({ defaultMessage: 'Role name' })}
                defaultValue={role.name}
                onChange={handleChange}
                invalid={errors.includes('name')}
              />
              {errors.includes('name') && (
                <FormFeedback>
                  {intl.formatMessage({ defaultMessage: 'This field is required' })}
                </FormFeedback>
              )}
            </FormGroup>
            <FormGroup>
              <Label for="inpRoleDescription">
                {intl.formatMessage({ defaultMessage: 'Description' })}
              </Label>
              <Textarea
                name="description"
                id="inpRoleDescription"
                className="form-control"
                placeholder="Role description (optional)"
                defaultValue={role.description}
                onChange={handleChange}
              />
            </FormGroup>
          </div>
        </div>
      </div>
      <AdminEditButtons
        {...props}
        deleteText={intl.formatMessage({ defaultMessage: 'Delete Role' })}
        hideDelete={roleId === null}
        handleDelete={handleDelete}
      />
    </ErrorBoundary>
  );
};

AdminRoleEditMainEdit.propTypes = {
  role: PropTypes.object,
  roleId: PropTypes.string,
  errors: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

AdminRoleEditMainEdit.defaultProps = {
  role: null,
  roleId: null,
};

export default AdminRoleEditMainEdit;
